import { ButtonVariant, ButtonSize } from './types';

/**
 * Maps Omega button variant to Shadcn button variant
 */
export const mapVariantToShadcn = (variant?: ButtonVariant): string => {
    if (!variant) return 'primary';

    const variantMap: Record<string, string> = {
        'Primary': 'primary',
        'Secondary': 'secondary',
        'Neutral': 'secondary', // Neutral maps to secondary in Shadcn
        'Plain': 'ghost' // Plain maps to ghost in Shadcn
    };

    return variantMap[variant] || 'primary';
};

/**
 * Maps Omega button size to Shadcn button size
 */
export const mapSizeToShadcn = (size?: ButtonSize): string => {
    if (!size) return 'md';

    const sizeMap: Record<string, string> = {
        'Small': 'sm',
        'Medium': 'md',
        'Large': 'lg',
        'Tiny': 'sm' // Tiny maps to sm in Shadcn
    };

    return sizeMap[size] || 'md';
};

